(ns very.sentry.core
  (:require
    ["raven-js" :as raven]
    [oops.core :refer [oset!]]
    [runtime.core :refer [DEBUG]]
    [very.re-frame.event-log :as log]
    [very.re-frame.errors :as err]
    )
  )

(defonce reporter ^js (atom nil))

(defn- get-error [err]
  ;; pass over errors that come from outside our domain -- we can't handle them:
  ;; https://blog.sentry.io/2016/05/17/what-is-script-error
  (if (not= -1 (.indexOf (.-message err) "Script error."))
    ;; we don't have access to the err obj so fabricate one here for a
    ;; consistent external api
    (js/Error. err)
    err))

(defn- preserve-namespaces [kw]
  (if (qualified-keyword? kw)
    (str kw)
    (name kw)))

(defn- report
  ([e] (report e {}))
  ([e info]
   (let [err (get-error e)
         evts (log/log)]
     (try
       (when DEBUG (logging.core/log {:events evts
                                      :event-log (pr-str evts)
                                      :db-before (pr-str (err/app-db))
                                      :db-after (pr-str (err/prev-app-db))
                                      :prev-event (pr-str (err/prev-event))
                                      :info info}))
       (.captureException @reporter err (clj->js {:extra {:events evts
                                                          :event-log (pr-str evts)
                                                          :db-before (pr-str (err/app-db))
                                                          :db-after (pr-str (err/prev-app-db))
                                                          :prev-event (pr-str (err/prev-event))
                                                          :info info}}
                                                 :keyword-fn preserve-namespaces))
       (catch :default e
         (logging.core/error "Error sending exception to Sentry: " e))
       (finally (logging.core/warn "Caught Error, reported to Sentry." err))))))

(defn init [{:keys [sentry-dsn release environment]}]
  ;; for debugging sourcemaps
  (oset! js/window "!very.!_debug.!sentry.!reporter" #(deref reporter))
  (oset! js/window "!very.!_debug.!sentry.!error" #(report (js/Error. (or % "default debug error"))))

  ;; config and capture the reporter
  (->>
    (doto raven
      (.config sentry-dsn
               (clj->js
                 (merge {"release" release
                         "environment" environment
                         "maxBreadcrumbs" 50
                         "autoBreadcrumbs" {"console" false}
                         "instrument" false}
                        (when DEBUG {"transport" #(do
                                                    (logging.core/error %))
                                     "debug" true}))))
      (.install))
    (reset! reporter)))

(defn- set-user [{:keys [email id name]}]
  (.setUserContext @reporter
                   (clj->js
                     {"email" email
                      "id" id
                      "username" name})))

(defn fx [dsl]
  (condp #(contains? %2 %1) dsl
    :set-user (set-user (:set-user dsl))
    ;; @TODO
    :exception nil
    :message nil
    :breadcrumb nil))

